export default "__VITE_ASSET__DcJ5QD3I__"